module.exports = __webpack_public_path__ + "img/ios-wallet.1e51b0c1.svg";